import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { isNil, Nillable } from '@web/utils';
import { BaseCollectionFilterRequestBuilder } from './base-collection-filter-request.builder';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';

export class BooleanCollectionFilterRequestBuilder<
  Filter,
> extends BaseCollectionFilterRequestBuilder<Filter> {
  public equal(): this {
    return this.operator(CollectionFilterOperator.Equal);
  }
  public equalFor(property: CollectionFilterKey<Filter>): this {
    return this.equal().property(property);
  }
  public override build(): Nillable<CollectionFilterRequest> {
    this.configureDefaultOperator();

    return super.build();
  }

  private configureDefaultOperator(): void {
    if (!isNil(this._operator)) {
      return;
    }

    this.equal();
  }
}
